import * as Html from "../../util/Html.ts";
import * as Storage from "../../lib/Storage.ts";
import Icons from "../../svg/Icons.ts";

Html.registerWidget('widget/form/rememberme',{initDom:initDom})

export function initDom(elem: HTMLElement){
  elem.style.cursor = 'pointer';
  let isChecked = Storage.localGet('rememberme')==='true';
  //init
  if(isChecked){
    elem.innerHTML = Icons.ic_checked.toString();
  }
  elem.addEventListener('click', function(){
    isChecked = !isChecked;
    elem.innerHTML = isChecked ? Icons.ic_checked.toString() : Icons.ic_checkbox.toString();
    Storage.localSet('rememberme', String(isChecked));
  });
}